/* =============================================
   ROUTINE BUILDER – Product Database
   ============================================= */
window.RoutineProductsDB = [
  // ===== 6BIOLOGICO =====
  {
    handle: "6biologico-bagno-doccia-argan",
    name: "Bagnodoccia Argan per pelli delicate",
    brand: "6Biologico",
    category: "corpo-detersione",
    routineStep: "corpo",
    price: 34.70,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-BagnodocciaArgan-art.jpg?v=1770808162",
    benefit: "Detersione delicata con Olio di Argan. Pelle vellutata e nutrita.",
    skinTypes: ["secca", "delicata", "tutti"],
    priorities: ["idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-corpo-armoniosa-bava-lumaca",
    name: "Crema Corpo Idratante alla Bava di Lumaca",
    brand: "6Biologico",
    category: "corpo-trattamento",
    routineStep: "corpo",
    price: 43.70,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-cremacorpoarmoniosa-art.jpg?v=1770806231",
    benefit: "Rigenerazione e idratazione profonda. Pelle elastica e compatta.",
    skinTypes: ["secca", "delicata", "tutti"],
    priorities: ["idratazione", "anti-age"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-viso-levigante-bava-lumaca",
    name: "Crema Levigante alla Bava di Lumaca",
    brand: "6Biologico",
    category: "viso-trattamento",
    routineStep: "crema-viso",
    price: 41.80,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Smoothingfacecream-art.jpg?v=1770806443",
    benefit: "Levigante per rughe e discromie. Senza siliconi, con Rosa Damascena.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "luminosita", "macchie"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-mani-unghie-bava-lumaca",
    name: "Crema Mani & Unghie alla Bava di Lumaca",
    brand: "6Biologico",
    category: "mani-trattamento",
    routineStep: "corpo",
    price: 36.50,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Cremamani_unghie-art.jpg?v=1770806193",
    benefit: "Rigenerante per mani secche e mature. Attenua le discromie.",
    skinTypes: ["secca", "delicata", "tutti"],
    priorities: ["idratazione", "anti-age", "macchie"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-viso-notte-intensiva-anti-acne",
    name: "Crema Notte Intensiva Purificante – Acido Azelaico",
    brand: "6Biologico",
    category: "viso-trattamento-notte",
    routineStep: "trattamenti-speciali",
    price: 42.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Cremanotteintensivaanti-acne-art.jpg?v=1770808034",
    benefit: "Purifica e riequilibra durante la notte. Riduce imperfezioni e pori.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-viso-nutriplus-bava-lumaca",
    name: "Crema Viso Nutriente alla Bava di Lumaca",
    brand: "6Biologico",
    category: "viso-trattamento",
    routineStep: "crema-viso",
    price: 41.80,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Nutriplusfacecream-art.jpg?v=1770806415",
    benefit: "Nutrimento intenso anti-età con Argan e Centella. Per pelli delicate.",
    skinTypes: ["secca", "delicata"],
    priorities: ["idratazione", "anti-age", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-crema-viso-olio-di-oliva",
    name: "Crema Viso Nutriente all'Olio di Oliva",
    brand: "6Biologico",
    category: "viso-trattamento",
    routineStep: "crema-viso",
    price: 40.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Cremavisooliod_oliva-art.jpg?v=1770808063",
    benefit: "Nutrimento mediterraneo per pelli secche. Antiossidante naturale.",
    skinTypes: ["secca"],
    priorities: ["idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-detergente-intimo",
    name: "Detergente Intimo – Propoli & Tea Tree",
    brand: "6Biologico",
    category: "igiene-intima",
    routineStep: "corpo",
    price: 34.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-DetergenteIntimo-art.jpg?v=1770806471",
    benefit: "Equilibrante e purificante. pH fisiologico, per tutta la famiglia.",
    skinTypes: ["tutti"],
    priorities: ["purificazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-latte-detergente-bava-lumaca",
    name: "Latte Detergente alla Bava di Lumaca",
    brand: "6Biologico",
    category: "viso-detersione",
    routineStep: "detersione",
    price: 37.70,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Lattedetergenteallabavadilumaca-art.jpg?v=1770806260",
    benefit: "Deterge nutrendo la pelle. Rigenerante con Rosa Damascena.",
    skinTypes: ["secca", "delicata", "tutti"],
    priorities: ["idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-olio-struccante-occhi",
    name: "Olio Struccante Occhi – Camomilla & Rosa Canina",
    brand: "6Biologico",
    category: "viso-detersione-occhi",
    routineStep: "detersione",
    price: 36.30,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-oliostruccanteocchi-art.jpg?v=1770807991",
    benefit: "Struccante delicato occhi. Rimuove anche trucco waterproof.",
    skinTypes: ["tutti"],
    priorities: ["idratazione"],
    gender: "donna",
    forManOnly: false
  },
  {
    handle: "6biologico-face-body-scrub-con-cellulosa-vegetale",
    name: "Scrub Viso e Corpo – Cellulosa Vegetale",
    brand: "6Biologico",
    category: "viso-corpo-esfoliazione",
    routineStep: "trattamenti-speciali",
    price: 37.50,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Face_bodyscrub-art.jpg?v=1770806496",
    benefit: "Esfoliazione delicata per viso e corpo. Pelle luminosa e rinnovata.",
    skinTypes: ["tutti"],
    priorities: ["luminosita", "purificazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-ace-serum",
    name: "Siero Multivitaminico A+C+E",
    brand: "6Biologico",
    category: "viso-siero",
    routineStep: "siero",
    price: 41.00,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-aceserum-art.jpg?v=1770808090",
    benefit: "Triplice azione antiossidante. Luminosità, compattezza e protezione.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-herbal-botulinum",
    name: "Siero Rassodante effetto Botulino",
    brand: "6Biologico",
    category: "viso-siero-anti-age",
    routineStep: "siero",
    price: 42.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-herbalbotulinum-art.jpg?v=1770808131",
    benefit: "Effetto botox-like naturale. Distende rughe di espressione.",
    skinTypes: ["tutti"],
    priorities: ["anti-age"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-siero-rigenerante-bava-lumaca",
    name: "Siero Rigenerante – Bava di Lumaca & Acido Ialuronico",
    brand: "6Biologico",
    category: "viso-siero",
    routineStep: "siero",
    price: 39.80,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-regeneratingserum-art.jpg?v=1770810231",
    benefit: "Booster rigenerante puro. Migliora rughe, discromie e imperfezioni.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "luminosita", "macchie"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "6biologico-tonico-viso-bava-lumaca",
    name: "Tonico Rigenerante alla Bava di Lumaca",
    brand: "6Biologico",
    category: "viso-tonico",
    routineStep: "tonico",
    price: 37.10,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/6biologico-Tonicovisoallabavadilumaca-art.jpg?v=1770806291",
    benefit: "Completa la detersione e minimizza i pori. Rinnovamento cutaneo.",
    skinTypes: ["tutti"],
    priorities: ["purificazione", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  // ===== E.BIOLAB =====
  {
    handle: "ebiolab-olio-vita-goji-biostar",
    name: "Complesso di Olii Multivitaminici – Vitagoji",
    brand: "E.biolab",
    category: "viso-olio",
    routineStep: "siero",
    price: 53.30,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Vitagoji-art.jpg?v=1770808334",
    benefit: "Olio antiossidante con Goji bio. Effetto glow naturale e luminoso.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-crema-corpo-bioregulation",
    name: "Crema Corpo Riequilibrante per pelli miste/grasse",
    brand: "E.biolab",
    category: "corpo-trattamento",
    routineStep: "corpo",
    price: 51.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Cremacorporiequilibrante-art.jpg?v=1770808423",
    benefit: "Nutre senza appesantire. Niacinamide per pelle equilibrata.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione", "idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-crema-viso-bioregulation",
    name: "Crema Viso Idratante Riequilibrante",
    brand: "E.biolab",
    category: "viso-trattamento",
    routineStep: "crema-viso",
    price: 48.40,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Cremavisopurificante-art.jpg?v=1770808451",
    benefit: "Controlla il sebo e uniforma l'incarnato. Finish opacizzante.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione", "idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-maschera-viso-bioregulation",
    name: "Maschera Viso Normalizzante – Argilla Rosa",
    brand: "E.biolab",
    category: "viso-maschera",
    routineStep: "trattamenti-speciali",
    price: 50.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Mascheravisonormalizzante-art.jpg?v=1770808486",
    benefit: "Purifica i pori e assorbe il sebo. Pelle opacizzata e fresca.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-latte-detergente-bioregulation",
    name: "Latte Detergente per pelli miste/impure",
    brand: "E.biolab",
    category: "viso-detersione",
    routineStep: "detersione",
    price: 43.50,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Lattedetergente-art.jpg?v=1770808549",
    benefit: "Detersione delicata per pelle impura. Formula biologica.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-tonico-bioregulation",
    name: "Tonico Riequilibrante per pelli miste/impure",
    brand: "E.biolab",
    category: "viso-tonico",
    routineStep: "tonico",
    price: 41.50,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Tonicoviso-art.jpg?v=1770808586",
    benefit: "Riequilibra e rinfresca. Aloe Vera bio e Pantenolo lenitivo.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione", "idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "ebiolab-siero-purity-bioregulation",
    name: "Siero Purity Bioregolatore – Niacinamide",
    brand: "E.biolab",
    category: "viso-siero-purificante",
    routineStep: "siero",
    price: 52.00,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Sieropurity-art.jpg?v=1770808386",
    benefit: "Regola il sebo e purifica. Doppio Acido Ialuronico + Niacinamide.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione", "idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  // ===== E.BIOLAB FORMAN (solo uomo) =====
  {
    handle: "ebiolab-siero-purificante-forman",
    name: "Siero Purificante ForMan",
    brand: "E.biolab",
    category: "viso-uomo-siero",
    routineStep: "siero",
    price: 52.00,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Sieropurificante-art.jpg?v=1770808617",
    benefit: "Purifica e riequilibra la pelle maschile. Ideale post-rasatura.",
    skinTypes: ["mista-grassa"],
    priorities: ["purificazione"],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-siero-anti-age-forman",
    name: "Siero Anti-age ForMan",
    brand: "E.biolab",
    category: "viso-uomo-siero",
    routineStep: "siero",
    price: 50.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Sierovisoanti-age-art.jpg?v=1770808645",
    benefit: "Distende e tonifica con Pepe di Sichuan. Anti-età maschile.",
    skinTypes: ["tutti"],
    priorities: ["anti-age"],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-siero-idratante-forman",
    name: "Siero Idratante ForMan",
    brand: "E.biolab",
    category: "viso-uomo-siero",
    routineStep: "siero",
    price: 47.10,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Sieroidratante-art.jpg?v=1770808671",
    benefit: "Idratazione multilivello per pelle maschile secca. Con Argan bio.",
    skinTypes: ["secca"],
    priorities: ["idratazione"],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-crema-viso-rivitalizzante-forman",
    name: "Crema Viso Rivitalizzante ForMan",
    brand: "E.biolab",
    category: "viso-uomo-trattamento",
    routineStep: "crema-viso",
    price: 46.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Cremavisorivitalizzante-art.jpg?v=1770808703",
    benefit: "Idratazione profonda e protezione quotidiana maschile.",
    skinTypes: ["tutti"],
    priorities: ["idratazione", "anti-age"],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-gel-pre-dopo-barba-forman",
    name: "Gel Pre e Dopo Barba",
    brand: "E.biolab",
    category: "viso-uomo-rasatura",
    routineStep: "post-rasatura",
    price: 45.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Gelpreedopobarba-art.jpg?v=1770808763",
    benefit: "Multifunzione pre e post barba. Ammorbidisce, lenisce, rinfresca.",
    skinTypes: ["tutti"],
    priorities: ["idratazione"],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-lozione-anti-caduta-forman",
    name: "Lozione Anti Caduta ForMan",
    brand: "E.biolab",
    category: "capelli-anticaduta",
    routineStep: "capelli",
    price: 40.80,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Lozioneanti-caduta-art.jpg?v=1770808733",
    benefit: "Rivitalizza il cuoio capelluto. Contrasta la caduta dei capelli.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "ebiolab-cera-per-capelli-forman-1",
    name: "Cera per Capelli Modellante",
    brand: "E.biolab",
    category: "capelli-styling",
    routineStep: "capelli",
    price: 41.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/E.biolab-Performancehairwax-art.jpg?v=1770808794",
    benefit: "Styling versatile con tenuta modulabile. Non unge né appesantisce.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "uomo",
    forManOnly: true
  },
  // ===== VIDEOR =====
  {
    handle: "videor-crema-corpo-satyria",
    name: "Crema Corpo Uva Rossa & Mandorla – SATYRIA",
    brand: "Videor",
    category: "corpo-trattamento",
    routineStep: "corpo",
    price: 43.50,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor-Satyria-Art.jpg?v=1770988238",
    benefit: "Antiossidante con Resveratrolo. Mantiene luminosità e abbronzatura.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "videor-crema-trattamento-macchie-elene",
    name: "Crema Trattamento Macchie – ELENE",
    brand: "Videor",
    category: "viso-trattamento-macchie",
    routineStep: "trattamenti-speciali",
    price: 44.10,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor-Elene-art.jpg?v=1770988207",
    benefit: "Acido Cogico per macchie e discromie. Incarnato uniforme e luminoso.",
    skinTypes: ["tutti"],
    priorities: ["macchie", "luminosita"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "videor-emulsione-post-rasatura-con-alcool-nerito",
    name: "Emulsione Post Rasatura – Nerito",
    brand: "Videor",
    category: "viso-uomo-post-rasatura",
    routineStep: "post-rasatura",
    price: 41.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor-Nerito-Art.png?v=1770995071",
    benefit: "Dopobarba rinfrescante classico con Mentolo e Aloe Vera.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "uomo",
    forManOnly: true
  },
  {
    handle: "videor-gel-lenitivo-idratante-post-rasatura-naxos",
    name: "Gel Post Depilazione Lenitivo – Naxos",
    brand: "Videor",
    category: "corpo-post-depilazione",
    routineStep: "post-rasatura",
    price: 40.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor-Naxos-art.jpg?v=1770996034",
    benefit: "Post depilazione senza alcool. Lenitivo per pelli sensibili.",
    skinTypes: ["delicata", "tutti"],
    priorities: ["idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "videor-siero-corpo-idratante-nutriente-nereide",
    name: "Siero Corpo Nutriente – Nereide",
    brand: "Videor",
    category: "corpo-siero",
    routineStep: "corpo",
    price: 42.20,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor_-_Nerito_-_Art_2.png?v=1770995128",
    benefit: "Levigante per décolleté e collo. Vitamina E antiossidante.",
    skinTypes: ["tutti"],
    priorities: ["anti-age", "idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "videor-olio-corpo-a-base-di-mandorle-dolci",
    name: "Olio Corpo alla Mandorla Dolce",
    brand: "Videor",
    category: "corpo-olio",
    routineStep: "corpo",
    price: 38.00,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Videor-oliocorpo-art.png?v=1770993713",
    benefit: "Mandorle pugliesi spremute a freddo. Previene smagliature e secchezza.",
    skinTypes: ["tutti"],
    priorities: ["idratazione"],
    gender: "unisex",
    forManOnly: false
  },
  // ===== IFA =====
  {
    handle: "ifa-olio-di-marula-puro",
    name: "Olio di Marula Puro – Multiuso",
    brand: "IFA",
    category: "multiuso-olio",
    routineStep: "siero",
    price: 37.60,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/IFA-OliodiMarula-art.jpg?v=1773056330",
    benefit: "Puro 100%, per viso, corpo, capelli e unghie. Filiera etica africana.",
    skinTypes: ["tutti"],
    priorities: ["idratazione", "anti-age"],
    gender: "unisex",
    forManOnly: false
  },
  // ===== VITALCRINIS =====
  {
    handle: "shampo-anti-caduta-vitalcrinis",
    name: "Shampoo Anti-Caduta Vitalcrinis",
    brand: "Vitalcrinis",
    category: "capelli-shampoo",
    routineStep: "capelli",
    price: 35.99,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Foto_1_shampoo.png?v=1741620070",
    benefit: "Detergente anticaduta con Caffeina e Biotina. Testato clinicamente.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "siero-anti-caduta-vitalcrinis",
    name: "Siero Anti-Caduta Vitalcrinis",
    brand: "Vitalcrinis",
    category: "capelli-siero",
    routineStep: "capelli",
    price: 35.99,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/Foto_1_Siero.png?v=1741619979",
    benefit: "Trattamento intensivo anticaduta. Stimola il follicolo e rinforza.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "unisex",
    forManOnly: false
  },
  {
    handle: "trattamento-anti-caduta-vitalcrinis",
    name: "Kit Anti-Caduta Vitalcrinis (Shampoo + Siero)",
    brand: "Vitalcrinis",
    category: "capelli-kit",
    routineStep: "capelli",
    price: 49.99,
    image: "https://cdn.shopify.com/s/files/1/0713/2440/1931/files/FotoBundle1_483900ff-ad69-481c-aa97-4d6e0417197a.png?v=1764670380",
    benefit: "Cura completa anticaduta: shampoo + siero. Garanzia 6 mesi.",
    skinTypes: ["tutti"],
    priorities: [],
    gender: "unisex",
    forManOnly: false
  }
];

/* Routine Steps definitions */
window.RoutineSteps = [
  { id: "detersione",          emoji: "🫧", label: "Detersione",          desc: "Il primo passo: rimuovere impurità e trucco per preparare la pelle." },
  { id: "tonico",              emoji: "💦", label: "Tonico",              desc: "Completa la detersione e prepara la pelle a ricevere i trattamenti." },
  { id: "siero",               emoji: "💎", label: "Siero",               desc: "Concentrato di attivi per trattare in profondità le esigenze della tua pelle." },
  { id: "crema-viso",          emoji: "🧴", label: "Crema Viso",          desc: "Sigilla idratazione e nutrimento. Il cuore della tua routine." },
  { id: "trattamenti-speciali",emoji: "🌿", label: "Trattamenti",         desc: "Esfolianti, maschere e trattamenti mirati per esigenze specifiche." },
  { id: "corpo",               emoji: "✨", label: "Corpo",               desc: "Cura e nutrimento per la pelle di tutto il corpo." },
  { id: "post-rasatura",       emoji: "💈", label: "Rasatura",            desc: "Lenisce e protegge la pelle dopo la rasatura o depilazione." },
  { id: "capelli",             emoji: "💇", label: "Capelli",             desc: "Trattamenti specifici per la salute e vitalità dei tuoi capelli." }
];
